(function(){
    'use strict';

    const init = () => {
        // Menu button listener
        document.querySelectorAll('#menu .menubutton').forEach((e) => {
            e.addEventListener('click', function() {
                document.body.classList.toggle('show-menu');
            });
        });

        // Close menu when licking on a link
        document.querySelectorAll('.mod_navigation.mainmenu a').forEach((e) => {
            e.addEventListener('click', function() {
                document.body.classList.remove('show-menu');
                return true;
            });
        });
    }

    if ('loading' === document.readyState) {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
